import { React, useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import FetchModule from '../../Model/Share/Network/FetchModule';

import SelectOffPath from '../../image/SelectOff.png';
import BlackPlusIcon from '../../image/BlackPlus.svg';
import CheckImage from '../../image/CheckImage.png';
import OnSearchImage from '../../image/OnSearchButton2.png';
import OffSearchImage from '../../image/OffSearchButton2.png';

export default function MembershipSortingSelectBox(props) {
  const { value, setValue } = props;

  const [isClicked, setIsClicked] = useState(false);
  const [options, setOptions] = useState([]);
  const [tmpValue, setTmpValue] = useState([]);

  const TopLevelRef = useRef();
  const TotalSelectRef = useRef();
	const SelectRef = useRef();

  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('membership/', 'GET');
        
        if (responseData.status === 200) {
          setOptions(responseData.data.memberShips);
        }
      }
    )();
  }, [])

  useEffect(() => {
    let newTempValue = [];

    for (let i = 0; i < options.length; i++) {
      for (let j = 0; j < value.length; j++) {
        if (options[i].name === value[j].name) {
          newTempValue.push(options[i]);
        }
      }
    }

    setTmpValue(newTempValue);
  }, [value, options])

  // 컴포넌트 밖을 클릭하면 셀렉트 창 닫기
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 컴포넌트 밖을 클릭하면 셀렉트 창 닫기
  function onClickOutSide(e) {
    if (TopLevelRef.current !== e.target && !TopLevelRef.current.contains(e.target)) {
      TotalSelectRef.current.style.height = '0px';
      TotalSelectRef.current.style.border = '0px';
      SelectRef.current.style.height = `0px`;
      SelectRef.current.style.overflow = 'hidden';
      setIsClicked(false);
    }
  }

  function onClick() {
    if (isClicked) {
      TotalSelectRef.current.style.height = '0px';
      TotalSelectRef.current.style.border = '0px';
      SelectRef.current.style.height = `0px`;
      SelectRef.current.style.overflow = 'hidden';
      setIsClicked(false);
    }
    else {
      TotalSelectRef.current.style.height = (32 * (options.length + 1 )) > 230 ? `264px` : (((32 * (options.length + 1)) + 36) + 'px');
      TotalSelectRef.current.style.border = '1px solid #FF8B48';
      SelectRef.current.style.height = (32 * (options.length + 1 )) > 230 ? `230px` : ((32 * (options.length + 1)) + 'px');
      SelectRef.current.style.overflowY = 'scroll';
      SelectRef.current.style.overflowX = 'none';
      setIsClicked(true);
    }
  }

  // 회원권 클릭시 //
  function optionalClick(index) {
    // 입력시 중복확인 => 존재하면 삭제, 존재하지 않으면 추가
    let newDefaultVal = tmpValue.slice();

    if (newDefaultVal.includes(options[index])) {
      let deletedIndex = 0;

      newDefaultVal.filter(function(item, idx) {
        // 두개가 같으면
        if (options[index] === item) {
          deletedIndex = idx;
          return;
        }
      })

      newDefaultVal.splice(deletedIndex, 1);
      setTmpValue(newDefaultVal);
    }
    else {
      newDefaultVal.push(options[index]);
      setTmpValue(newDefaultVal);
    }
  }

  // 확인 버튼 클릭시 //
  function onClickComplete() {
    setValue(tmpValue);
    onClick();
  }
  
  // 초기화 버튼 클릭시 //
  function onClickReset() {
    setValue([]);
    setTmpValue([]);
    onClick();
  }

	return (
    <TopLevelWrapper ref={TopLevelRef}>
      <SearchButton src={isClicked ? OnSearchImage : OffSearchImage} onClick={onClick}/>
      <TotalSelectBox ref={TotalSelectRef}>
      <SelectBox
        ref={SelectRef}
        isClicked={isClicked}>
        {
          options.map((data, index) =>
            <OptionWrapper key={index} onClick={() => optionalClick(index)}>
              <TextWrapper>
                <Option isClicked={tmpValue.includes(data)}>{data.name}</Option>
              </TextWrapper>
              { tmpValue.includes(data) && <Check src={CheckImage}/> }
            </OptionWrapper>
          )
        }
      </SelectBox>
      <CompleteButtonWrapper>
        <TextButton onClick={onClickComplete}>확인</TextButton>
        <TextButton onClick={onClickReset}>초기화</TextButton>
      </CompleteButtonWrapper>
      </TotalSelectBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 20px;
  height: 20px;
`;

const SearchButton = styled.img`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;

  border-radius: 4px;

  overflow: hidden;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const Check = styled.img`
  width: 12px;
  height: 9px;
`;

const TotalSelectBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 160px;
  height: 0px;

  margin-top: 25px;
  margin-left: -72px;

  border: 0px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 1);

  overflow: hidden;

  z-index: 2;

  transition: all 0.3s ease-in-out;
`;

const SelectBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 144px;
  height: 0px;

  padding: 0 8px 0 8px;

  border: 0px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 1);

  overflow: hidden;

  z-index: 2;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }

  &::-webkit-scrollbar {
    width: 9px;
  }

  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px #FF8B48;
    border: 3px solid transparent;
    height: 25px;
    border-radius: 200px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
    border: 4px solid transparent;
    background-color: transparent;
  }

  &::-webkit-scrollbar-track-piece {
    background-color: transparent;
  }
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;

  margin: 6px 0px 6px 0px;

  &:hover {
    cursor: pointer;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: calc(100% - 16px);
  height: 19px;

  overflow: hidden;
`;

const Option = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 13px;

  color: ${props => props.isClicked ? `#FF8B48` : `#555555`};

  margin: 0 0 0 0;
  padding: 0 0 0 0;
`;

const CompleteButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 8px 0px 8px;

  gap: 8px;

  width: calc(100% - 16px);
  height: 36px;

  border-top: 1px solid #DBDBDB;
`;

const TextButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #BDBDBD;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    color: #FF8B48;
  }
`;